import { parseUrl, stringify } from 'query-string'
import _ from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import { isMobile } from "@/util/common.util";
Vue.config.productionTip = false

const { url, query } = parseUrl(location.href)
const storeFlagIsN = _.get(query, 'store', '').toLowerCase() === 'n'
const isMobileBrowser = isMobile()
const MOBILE_WEB_ORIGIN = 'https://m.wavve.com'
const PC_WEB_ORIGIN = 'https://www.wavve.com'

const goRedirectWith = (redirectOrigin) => {
  delete query.store
  const targetUrl = url.replace(location.origin, redirectOrigin)
  location.replace(targetUrl + (Object.keys(query).length > 0 ? '?' + stringify(query) : ''))
}

if(!isMobileBrowser) {
  goRedirectWith(PC_WEB_ORIGIN)
}else if(storeFlagIsN){
  goRedirectWith(MOBILE_WEB_ORIGIN)
}else {
  new Vue({
    render: h => h(App)
  }).$mount('#app')
}


